// Webpack Imports
import * as bootstrap from 'bootstrap';
import $, { event } from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel-latest';

import './js/components/icon-card-accordion';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );


//Detect IOS
	var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

	if (isIOS) {
		$('body').addClass('iOS-device');
		$('.block-share-social-buttons li').addClass('me-3');
	}
// Fix for 100vh in mobile iOS
addEventListener('click', function () {
	const bodyHasClass = document.body.classList.contains(
		'menu-open'
	);
	const navbarCollapse = document.querySelector('.navbar-collapse');
	if (bodyHasClass && isIOS || ($(window).width() < 768)) {
		const updateViewportElements = () => {
			navbarCollapse.style.minHeight = `${window.innerHeight - 155}px`;
		};
		window.addEventListener('resize', updateViewportElements);
		updateViewportElements();
		} else {
			const updateViewportElements = () => {
				navbarCollapse.style.minHeight = `unset`;
			};
			window.addEventListener('resize', updateViewportElements);
			updateViewportElements();
		}
})
// Content protection when copying from the site
document.oncopy = function () { 
		var bodyElement = document.body; 
		var selection = getSelection(); 
		var href = document.location.href; 
		var copyright = "<br><br>Origin: <a href='"+ href +"'>" + href + "</a><br>©  Syteca"; 
		var text = selection + copyright; 
		var divElement = document.createElement('div'); 
		divElement.style.position = 'absolute'; 
		divElement.style.left = '-99999px'; 
		divElement.innerHTML = text; 
		bodyElement.appendChild(divElement); 
		selection.selectAllChildren(divElement); 
		setTimeout(function() { 
			bodyElement.removeChild(divElement);
		}, 0);
	}; 
} )();

jQuery(function($) {
	//Adding styles to menu open
	if ($(window).width() > 1024) {
		$(document).ready(function() {
			var $dropdownToggles = $('.navbar .dropdown-toggle');
			$dropdownToggles.hover(
			  function() {
				$dropdownToggles.not(this).css('opacity', '60%');
			  },
			  function() {
				$dropdownToggles.css('opacity', '100%');
			  }
			);
		  });
		var lastClicked = null;

		$('#navbar .nav-link.dropdown-toggle').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);
			
			if (lastClicked && lastClicked.is($this)) {
				$('body').removeClass('menu-open');
				lastClicked = null;
			} else {
				$('body').addClass('menu-open');
				lastClicked = $this;
			}
		});

		$('.right-block-header .language-switcher .nav-link.dropdown-toggle').on('click', function(e) {
				$('body').addClass('menu-open');
				lastClicked = null;
		});
	
		$(document).on('click', function(e) {
			var $langSubmenu = $('.right-block-header .language-switcher .js-wpml-ls-sub-menu');
			setTimeout(function() {
				if ($('#navbar .dropdown-menu.show').length === 0 && ($langSubmenu.css('visibility') === 'hidden' || !$langSubmenu.attr('style')) ) {
					$('body').removeClass('menu-open');
					lastClicked = null;
				}
				if ($('.full-width .dropdown-menu.show').length != 0) {
					var menuHeight = $('.dropdown-menu.show').outerHeight();
					lastClicked = null;
				} else {
				}
			}, 100);
		});
	}
	
	if ($(window).width() <= 1024 && $(window).width() >= 768) {
		$(document).on("click", function() {
			if($('#menu-main-menu .dropdown-menu').hasClass( "show" )) {
				$('#navbar').addClass('no-scroll');
			} else {
				$('#navbar').removeClass('no-scroll');
			}
			var $langSubmenu = $('.right-block-header .language-switcher .js-wpml-ls-sub-menu');
			setTimeout(function() {
				if ($('.navbar-toggler').attr('aria-expanded') === 'false' && ($langSubmenu.css('visibility') === 'hidden' || !$langSubmenu.attr('style')) ) {
					$('body').removeClass('menu-open');
				} else {
					$('body').addClass('menu-open');
				}
			}, 100);
		});
	} 
	
	if ($(window).width() < 768) {
		$('.navbar-toggler-icon').on("click", function(){
				$('body').toggleClass('menu-open');
		})
	}

	if ($(window).width() <= 1024) {
		$(document).ready(function() {
			$('.full-width.menu-item').each(function () {
				$(this).children('a:first').attr('data-bs-toggle', '');
				if (!$(this).hasClass('menu-item-partners')) {
					$(this).find('.inner-menu').addClass('d-none');
				}
			});
			$('.full-width.menu-item .dropdown-menu .menu-item-has-children').each(function () {
				$(this).children('a').css('pointer-events', 'none');
			});
			$('.full-width.menu-item .dropdown-menu .menu-item-has-children .inner-menu').each(function () {
				$(this).children('a').css('pointer-events', 'auto');
			});
		});

		$('.full-width.menu-item > a').on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass('show');
			$(this).siblings('.dropdown-menu').toggleClass('show');
		});

		$('.menu-item.menu-item-has-children > a').on("click", function (e) {
			e.preventDefault();
			$(this).parent().toggleClass('show');
			$('.menu-item.menu-item-has-children').not($(this).parent()).removeClass('show');
			$('.menu-item.menu-item-has-children > a').not(this).removeClass('show');
			$('.menu-item.menu-item-has-children .dropdown-menu').not($(this).siblings('.dropdown-menu')).removeClass('show');
		});

		$('.full-width.menu-item .dropdown-menu .menu-item-has-children').on("click", function(){
			$(this).find('.inner-menu').toggleClass('d-none');
			$(this).find('>a').toggleClass('show');
		})
	} 
	


	// header scrolling
	$(window).on('scroll', function(){
        if ($(window).scrollTop() >= 70) {
            $('#header').addClass('header-scrolling');
        }
        else if ($(window).scrollTop() <= 70) {
            $('#header').removeClass('header-scrolling');
        }
    });
	// page nav scrolling
	$(window).on('scroll', function(){
        if ($(window).scrollTop() >= 350) {
            $('#page_inner_navbar').addClass('page-navbar-scrolling');
			$('#page_inner_navbar').css('transition', 'padding-bottom 1s');
			$('#page_inner_navbar + div').css('margin-top', '64px');
        }
        else if ($(window).scrollTop() <= 350) {
            $('#page_inner_navbar').removeClass('page-navbar-scrolling');
			$('#page_inner_navbar + div').css('margin-top', '');
        }
    });
});

jQuery(function($) {
	$('.fancybox-click-img img').attr('data-fancybox', 'image');
	Fancybox.bind('[data-fancybox="image"]', {
        Hash: false,
        Thumbs: false,
        compact: false,
        contentClick: "iterateZoom",
		groupAttr: false,
        Toolbar: {
          display: {
            left: [],
            middle: [
				"zoomIn",
				"zoomOut",
				"toggle1to1",
				"rotateCCW",
				"rotateCW",
				"close"
			],
            right: [],
          },
        },

        Images: {
          Panzoom: {
            maxScale: 2,
          },
        },
      });
});

$(document).ready(function() {
	if ($(window).width() >= 768 && $(window).width() <= 1024) {
    $('li.footer-dropdown-item').first().find('ul.sub-menu').first().addClass('open');
	$('li.footer-dropdown-item.column-item').each(function() {
        $(this).find('ul.sub-menu').addClass('column');
    });
	$('li.footer-dropdown-item.row-item').each(function() {
        $(this).find('ul.sub-menu').addClass('row');
    });
	$('li.footer-dropdown-item').first().addClass('active');
    $('li.footer-dropdown-item').on('click', function() {
		$('li.footer-dropdown-item').removeClass('active');
        $('.menu .sub-menu').removeClass('open');
        var $firstSubMenu = $(this).find('ul.sub-menu').first();
        if (!$firstSubMenu.hasClass('open')) {
			$(this).addClass('active');
            $firstSubMenu.addClass('open');
        }
    });
        }
});

// Sliders

$('.customers-slider').slick({
	infinite: true,
	  slidesToShow: 4,
	centerMode: true,
	centerPadding: '5%',
	arrows: false,
	speed: 5000,
	autoplay: true,
	autoplaySpeed: 0,
	cssEase: 'linear',
	rtl: $('html').attr('dir') === 'rtl',
	responsive: [
		{
		  breakpoint: 992,
		  settings: {
			slidesToShow: 3,
		  }
		},					
	]
});

jQuery(function($) {
	$('.card-industry a.areoi-full-link, .div-a-target_blank a.areoi-full-link').each(function() {
		$(this).attr('rel', 'noreferrer noopener').attr('target', '_blank');
	});
});

jQuery(function($) {
	$('.post-card .hoverable').hover(
		function () {
		  const $postCard = $(this).closest('.post-card');
		  $postCard.find('.hoverable').addClass('hover-effect');
		},
		function () {
		  const $postCard = $(this).closest('.post-card');
		  $postCard.find('.hoverable').removeClass('hover-effect');
		}
	  );
});